var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.error),expression:"!error"}]}),_c('Page500',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }